import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../api/firebaseConfig";
import 'bootstrap/dist/css/bootstrap.min.css';

function InvoiceList() {
  const [invoices, setInvoices] = useState([]);
  const [visibleCount, setVisibleCount] = useState(5);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const q = query(collection(db, "invoices"), orderBy("dateOfIssue", "desc"));
        const querySnapshot = await getDocs(q);
        const invoiceData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setInvoices(invoiceData);
      } catch (error) {
        console.error("Error fetching invoices: ", error);
      }
    };

    fetchInvoices();
  }, []);

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 5);
  };

  const visibleInvoices = invoices.slice(0, visibleCount);

  return (
    <div className="mt-5">
      <h3 className="mb-4">Saved Invoices</h3>
      {invoices.length === 0 ? (
        <p>No invoices found.</p>
      ) : (
        <>
          {visibleInvoices.map((invoice) => (
            <div key={invoice.id} className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">
                  Invoice #{invoice.invoiceNumber || "N/A"}
                </h5>
                <h6 className="card-subtitle mb-2 text-muted">
                  Date: {invoice.dateOfIssue || "N/A"}
                </h6>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <strong>Bill From:</strong>
                    <p>{invoice.billFrom || "N/A"}</p>
                  </div>
                  <div className="col-md-6">
                    <strong>Bill To:</strong>
                    <p>{invoice.billTo || "N/A"}</p>
                  </div>
                </div>

                <strong>Items:</strong>
                <ul className="list-group mb-3">
                  {invoice.items && invoice.items.map((item, idx) => (
                    <li key={idx} className="list-group-item d-flex justify-content-between">
                      <div>
                        <strong>{item.name}</strong>
                        <div className="text-muted small">{item.description}</div>
                      </div>
                      <div>
                        {item.quantity} × {invoice.currency}{item.price}
                      </div>
                    </li>
                  ))}
                </ul>

                <div className="d-flex justify-content-end">
                  <div className="text-end">
                    <p className="mb-1">Subtotal: {invoice.currency}{invoice.subTotal || 0}</p>
                    <p className="mb-1">Tax : {invoice.currency}{invoice.taxAmount || 0}</p>
                    <h5>Total: {invoice.currency}{invoice.total || 0}</h5>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {visibleCount < invoices.length && (
            <div className="d-flex justify-content-center">
              <button className="btn btn-primary" onClick={handleLoadMore}>
                Load More
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default InvoiceList;
